import { datadogRum } from '@datadog/browser-rum';
import { getCookie } from '../../lib/utils/cookie';

import json from '../../../package.json';
import { getEnvironment } from 'config';

export const createDataDogReporter = (country: Country, isMobile: boolean): void => {
    const { dataDog } = getEnvironment();

    const { version } = json;

    const {
        availableDataDog,
        applicationId,
        clientToken,
        site,
        env,
        sessionReplaySampleRate,
        sessionSampleRate,
    } = dataDog;

    if (availableDataDog) {
        const service =
            env === 'prod'
                ? `ripley-checkout-${country}---one-step`.toLowerCase()
                : `checkout-${country}---${env}`.toLowerCase();

        datadogRum.init({
            applicationId,
            clientToken,
            site,
            service,
            env,
            version,
            sessionSampleRate,
            sessionReplaySampleRate,
            trackUserInteractions: true,
            defaultPrivacyLevel: 'mask-user-input',
        });

        const cartId = getCookie('NMKR_TRA') ?? '';
        const channel = isMobile ? 'app' : 'web';

        datadogRum.setUser({
            id: cartId,
            cartId,
            channel,
        });

        datadogRum.startSessionReplayRecording();
    }
};
